import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const linkEmailDomainToTeams = {
  name: "linkEmailDomainToTeams" as const,
  input: z.object({
    fromTeamId: zExt.objectId(),
    domain: z.string().trim().min(1),
    toTeamIds: z.array(zExt.objectId()).min(1).max(25),
  }),
  output: z.object({ linkedTeamIds: z.array(zExt.objectId()) }),
};
